import type { ComponentProps, FC, ReactNode } from 'react';

import { Link } from '@remix-run/react';
import cn from 'classnames';

import {
  type PillButtonSize,
  type PillButtonVariant,
  pillButtonBaseClass,
  pillButtonSizes,
  pillButtonVariants,
} from './PillButton';

interface PillLinkProps extends Omit<ComponentProps<typeof Link>, 'className' | 'children'> {
  variant: PillButtonVariant;
  size?: PillButtonSize;
  fullWidth?: boolean;
  className?: string;
  children: ReactNode;
}

export const PillLink: FC<PillLinkProps> = ({
  variant,
  size = 'md',
  fullWidth = false,
  className,
  children,
  ...props
}) => {
  return (
    <Link
      className={cn(
        pillButtonBaseClass,
        pillButtonSizes[size],
        pillButtonVariants[variant],
        { 'w-full': fullWidth },
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
};
